import './facultySchedule.scss'
import TotalFees from './TotalFees'
import Schedule from '../../../components/schedule/Schedule'
import { useSelector } from 'react-redux'
import { schedule, UI_CONSTANT } from '../../../utility/constants'
import { loading } from '../../../store/slice/faculty/faculty-dashboard.slice'
import Loader from '../../../components/loader/Loader'

function FacultySchedule() {
  const userName = useSelector((state) => state?.auth?.user?.result?.userData?.userName)

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> && <div className='FacultySchedule-wrapper'>
      <div className='FacultySchedule-header'>
        <div className='FacultySchedule-header-left'>
          <p>Hello, {userName} </p>
          {/* <p className='breadCrumb'>{UI_CONSTANT.DASHBOARD}</p> */}
        </div>
      </div>

      <div className='faculty-schedule-calender-wrapper'>
        <Schedule schedule={schedule} />

        <div className='FacultySchedule-right-div'>
          <TotalFees />
        </div>
      </div>
    </div>}
    </>
  )
}

export default FacultySchedule
